const ALL_LOCALES = [
  { id: 'en', name: 'English', flag: 'flag-US' },
  {
    id: 'ar', name: 'العربية', direction: 'rtl', flag: 'flag-KW',
  },
  {
    id: 'ur', name: 'اردو', direction: 'rtl', flag: 'flag-PK',
  },
  { id: 'ku', name: 'Kurdî', flag: 'flag-IR' },
  { id: 'ru', name: 'русский', flag: 'flag-RU' },
  { id: 'bg', name: 'български', flag: 'flag-BG' },
  { id: 'hu', name: 'Magyar', flag: 'flag-HU' },
  { id: 'pt', name: 'Português', flag: 'flag-PT' },
  { id: 'es', name: 'Español', flag: 'flag-ES' },
  { id: 'ca', name: 'Català', flag: 'flag-ES' },
  { id: 'fr', name: 'Français', flag: 'flag-FR' },
  { id: 'fa', name: 'فارسی', flag: 'flag-IR' },
  { id: 'de', name: 'Deutsche', flag: 'flag-DE' },
  { id: 'tr', name: 'Türkçe', flag: 'flag-TR' },
  { id: 'az', name: 'Azəri', flag: 'flag-AZ' },
  { id: 'hy', name: 'հայերեն', flag: 'flag-HY' },
  { id: 'it', name: 'Italiano', flag: 'flag-IT' },
  { id: 'nl', name: 'Nederlands', flag: 'flag-NL' },
  { id: 'el', name: 'Ελληνικά', flag: 'flag-ET' },
  { id: 'ka', name: 'ქართველი', flag: 'flag-KA' },
  { id: 'ro', name: 'Română', flag: 'flag-RO' },
  { id: 'sv', name: 'Svenska', flag: 'flag-SV' },
  { id: 'fi', name: 'Suomalainen', flag: 'flag-FI' },
  { id: 'hr', name: 'Hrvatski', flag: 'flag-HR' },
  { id: 'pl', name: 'Polskie', flag: 'flag-PL' },
  { id: 'et', name: 'Eestlane', flag: 'flag-ET' },
  { id: 'no', name: 'Norsk', flag: 'flag-NO' },
  { id: 'sq', name: 'Shqiptare', flag: 'flag-SQ' },
  { id: 'ha', name: 'Hausa', flag: 'flag-HA' },
  { id: 'zh', name: '中文', flag: 'flag-CN' },
  { id: 'ja', name: '日本人', flag: 'flag-JA' },
  { id: 'ko', name: '한국인', flag: 'flag-KO' },
  { id: 'bn', name: 'বাংলা', flag: 'flag-BN' },
  { id: 'hi', name: 'हिंदी', flag: 'flag-IN' },
  { id: 'th', name: 'ไทย', flag: 'flag-TH' },
  { id: 'lo', name: 'ລາວ', flag: 'flag-LO' },
  { id: 'km', name: 'ខ្មែរ', flag: 'flag-KM' },
  { id: 'kk', name: 'Қазақ', flag: 'flag-KK' },
  { id: 'mn', name: 'Монгол', flag: 'flag-MN' },
  { id: 'vi', name: 'Tiếng Việt', flag: 'flag-VI' },
  { id: 'ma', name: 'Bahasa Melayu', flag: 'flag-MA' },
]

export default ALL_LOCALES
